export default "__VITE_ASSET__Cx6VOoE8__"